<template>
  <div class="dacb-location-panel" :class="{ '-local': isLocal }">
    <iframe
      class="dacb-location-map"
      :src="embedUrl"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
      title="Location map"
    ></iframe>
    <a class="dacb-location-link" :href="openStreetMapUrl" target="_blank" rel="noopener noreferrer">
      Open in OpenStreetMap
    </a>
  </div>
</template>

<script>
export default {
  name: "LocationPanel",

  props: {
    location: {
      type: Object,
      required: true
    },
    isLocal: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    safeLat() {
      return Number(this.location.lat).toFixed(6);
    },

    safeLng() {
      return Number(this.location.lng).toFixed(6);
    },

    embedUrl() {
      const lat = Number(this.safeLat);
      const lng = Number(this.safeLng);
      const delta = 0.005;
      const bbox = [lng - delta, lat - delta, lng + delta, lat + delta].join(",");

      return `https://www.openstreetmap.org/export/embed.html?bbox=${encodeURIComponent(
        bbox
      )}&layer=mapnik&marker=${this.safeLat}%2C${this.safeLng}`;
    },

    openStreetMapUrl() {
      return `https://www.openstreetmap.org/?mlat=${this.safeLat}&mlon=${this.safeLng}#map=15/${this.safeLat}/${this.safeLng}`;
    }
  }
};
</script>

